import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import RelatedWorks from "./RelatedWorks";
import "./WorkDetail.css";

export default function PlugzmartDetails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
          Plugzmart – Smart EV Charging Solutions
        </h1>

        <p className="project-description">
          We developed a series of promotional videos and social media creatives for Plugzmart, helping communicate the brand's vision for smarter and more accessible EV charging infrastructure. The content focused on product features, technology benefits, and brand engagement, creating a strong and consistent digital identity across multiple platforms.        </p>

        <div className="project-tags">
          <span className="info-tag">Video Editing</span>
          <span className="info-tag"> Social Media Design </span>
          <span className="info-tag"> Motion Graphics </span>
        </div>
      </section>

      {/* Full landscape video */}
      <div className="project-full-image-section">
        <video style={{ minHeight: "635px", height: "90vh" }}
          src="https://ascentbw.com/Images/Plugzmart/Vid2.webm"
          autoPlay
          loop
          muted
          playsInline
        />
      </div>


      {/* Two portrait videos in a row left and right */}
      <section className="project-split-images-section">
        <video
          src="https://ascentbw.com/Images/Plugzmart/Half1.webm"
          autoPlay
          loop
          muted
          playsInline
        />
        <video
          src="https://ascentbw.com/Images/Plugzmart/Half2.webm"
          autoPlay
          loop
          muted
          playsInline
        />
      </section>



      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We created a highly engaging corporate presentation highlighting the engineering complexity and product aesthetics of Plugzmart's smart EV chargers, emphasizing reliability, safety, and rapid deployment capabilities."
        </div>
      </section>

      <div className="project-full-image-section">
        <video style={{ minHeight: "810px", height: "100vh" }}
          src="https://ascentbw.com/Images/Plugzmart/Vid1.webm"
          autoPlay
          loop
          muted
          playsInline
        />
      </div>



      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "Designed to inspire and inform, the motion assets reinforce Plugzmart's position as a pioneering leader in India's electric vehicle charging infrastructure."
        </div>
      </section>
      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Plugzmart/Full1.webp" alt="Feston Brand Exhibition" />
      </div>

      <section className="project-split-images-section">
        <img style={{ minHeight: "930px" }} src="https://ascentbw.com/Images/Plugzmart/Half3.webp" alt="Feston Living Room" />
        <img style={{ minHeight: "930px" }} src="https://ascentbw.com/Images/Plugzmart/Half4.webp" alt="Feston Materials" />
      </section>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We created high-impact social media campaigns to promote Plugzmart’s EV charging solutions, ensuring consistent messaging across all digital platforms. The designs highlight key features, benefits, and the technology’s role in advancing India's EV infrastructure."
        </div>
      </section>

      <RelatedWorks excludePath="/works/plugzmart" />
      <Footer />
    </div>
  );
}
